import Vue from "vue";
import VueRouter from 'vue-router'
import Simuleaqui from '../views/Simule-aqui.vue'
import Dadosbeneficiario from '../views/Dados-beneficiario.vue'
import Gerenciardependentes from '../views/Gerenciar-dependentes.vue'
import Seuplano from '../views/Seu-plano.vue'
import Cadastrar from '../views/Cadastrar.vue'
import Login from '../views/Login.vue'
import DPSForm from '../views/DPS-form.vue'
import Pagamento from '../views/Pagamento.vue'
import FinalizarProposta from '../views/Finalizar-proposta.vue'
import AssinarProposta from '../views/Assinar-proposta.vue'
import EnviarDocumentos from '../views/Enviar-documentos.vue'
import PropostaFinalizada from '../views/Proposta-finalizada.vue'
import Components from '../views/Components.vue'
import Page404 from '../views/Page404.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    beforeEnter: (to, from, next) => {
      next('/simule-aqui');
    },
    meta: { gtm: "home" },
  },
  {
    path: '/simule-aqui',
    name: 'Simule-aqui',
    component: Simuleaqui,
    meta: { gtm: "Simule-aqui" },
  },
  {
    path: '/dados-beneficiario',
    name: 'Dados-beneficiario',
    component: Dadosbeneficiario,
    meta: { gtm: "Dados-beneficiario" },
  },
  {
    path: '/adicionar-dependentes',
    name: 'Gerenciar-dependentes',
    component: Gerenciardependentes,
    meta: { gtm: "Gerenciar-dependentes" },
  },
  {
    path: '/seu-plano',
    name: 'Seu-plano',
    component: Seuplano,
    meta: { gtm: "Seu-plano" },
  },
  {
    path: '/cadastrar',
    name: 'cadastrar',
    component: Cadastrar,
    meta: { gtm: "cadastrar" },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { gtm: "login" },
  },
  {
    path: '/declaracao-saude',
    name: 'dps-form',
    component: DPSForm,
    meta: { gtm: "dps-form" },
  },
  {
    path: '/informacoes-pagamento',
    name: 'informacoes-pagamento',
    component: Pagamento,
    meta: { gtm: "informacoes-pagamento" },
  },
  {
    path: '/finalizar-proposta',
    name: 'finalizar-proposta',
    component: FinalizarProposta,
    meta: { gtm: "finalizar-proposta" },
  },
  {
    path: '/assinar-proposta',
    name: 'assinar-proposta',
    component: AssinarProposta,
    meta: { gtm: "assinar-proposta" },
  },
  {
    path: '/enviar-documentos',
    name: 'enviar-documentos',
    component: EnviarDocumentos,
    meta: { gtm: "enviar-documentos" },
  },
  {
    path: '/adesao-finalizada',
    name: 'adesao-finalizada',
    component: PropostaFinalizada,
    meta: { gtm: "adesao-finalizada" },
  },
  { 
    path: '*', 
    component: Page404
  },
  {
    path: '/components',
    name: 'Components',
    component: Components,
    meta: { gtm: "Components" },
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
